import React from "react";
import PropTypes from "prop-types";

import DateTime from "components/DateTime";

import styles from "forms/forms.css";

const DateRangeField = ({ field: { name, value = {} }, form, label, separator }) => (
  <div className={styles.field}>
    <label>{label}</label>
    <div className={styles.range}>
      <DateTime
        date={value.from}
        onSave={({ date }) => form.setFieldValue(name, { ...value, from: date })}
        isInput
        isTimeHidden
      />
      <div className={styles.separator}>{separator}</div>
      <DateTime
        date={value.to}
        onSave={({ date }) => form.setFieldValue(name, { ...value, to: date })}
        isInput
        isTimeHidden
      />
    </div>
  </div>
);

DateRangeField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.object,
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
  }),
  label: PropTypes.string,
  separator: PropTypes.string,
};

DateRangeField.defaultProps = {
  separator: "to",
};

export default DateRangeField;
